import { apiJson } from './http'
import { postSse } from './ssePost'

export async function getChatHistory(sessionId) {
  const res = await apiJson(`/api/v1/chat/history/${sessionId}`)
  return res.messages || []
}

export function sendChatSse(payload, { signal, onEvent } = {}) {
  return postSse('/api/v1/chat/send', payload, { signal, onEvent })
}
